import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import PracticeSingleDetailsTwo from '../../components/practice-components/PracticeSingleDetailsTwo';
import FooterOne from '../../common/footer/FooterOne';

const PracticeSingleTwo = () => {
    return (
        <>
        <HeaderOne />

        <BreadcrumbOne 
            title="Practice Single 2"
            rootUrl="/"
            parentUrl="Home"
            currentUrl="Practice Single 2"
        />
        
        <PracticeSingleDetailsTwo />
        
        <FooterOne />
        </>
    )
}
    
export default PracticeSingleTwo;